<template>
  <div class="bi-layout compair-layout">
    <h1 class="mb-8">Google Ads Vergleichen</h1>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2">
        <BiCompairBoxGoogle
          :max-y="maxY"
          @max-y-updated="e => onMaxY('a', e)"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <BiCompairBoxGoogle
          :max-y="maxY"
          @max-y-updated="e => onMaxY('b', e)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BiCompairBoxGoogle from "@/components/bi/BiCompairBoxGoogle.vue";

export default {
  components: {
    BiCompairBoxGoogle
  },
  data: () => ({
    maxValues: { a: 0, b: 0 }
  }),
  computed: {
    maxY() {
      return Math.max(this.maxValues["a"], this.maxValues["b"]);
    }
  },
  methods: {
    onMaxY(chartIdx, value) {
      this.maxValues[chartIdx] = value;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
